// 418, 423, 425- React hydration errors
export const getIsReactHydrationError = (message: string) =>
  message.includes('Minified React error #418') ||
  message.includes('Minified React error #423') ||
  message.includes('Minified React error #425') ||
  message.includes('There was an error while hydrating') ||
  message.includes('Text content does not match server-rendered HTML') ||
  message.includes('Hydration failed because the initial UI does not match what was rendered on the server');
